
import {StoreBase, StoreDataType} from "shared/utilities/Store/StoreBase";
import {observable} from "mobx";
import {EventManager} from "shared/utilities/Events/EventManager";
import {SectionOptionsEnum} from "InternalShared/PageBuilder/Services/DragDropService";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {GetControlOptions} from "InternalShared/Events/GetControlOptions";
import {PDFControlOptionsGenerator} from "InternalShared/PageBuilder/Controls/Core/Generators/PDFControlOptionsGenerator";
import {CurrencySettings} from "PageBuilder/utils/CurrencySettings";


export class PageOptions extends StoreBase{
    @observable
    Fields:PDFControlBaseOptions[];
    @observable
    HeaderSection:SectionOption;
    @observable
    FooterSection:SectionOption;
    @observable
    ContentSection:SectionOption;
    protected LoadDefaultValues() {
        this.Fields=[];
        this.HeaderSection=new SectionOption().Merge({Type:SectionOptionsEnum.header,Height:100});
        this.ContentSection=new SectionOption().Merge({Type:SectionOptionsEnum.content,Height:923});
        this.FooterSection=new SectionOption().Merge({Type:SectionOptionsEnum.footer,Height:100});
    }

    protected GetValueFromLoader(property: any, value: any): any {
        if(property=='Fields')
        {
            let fields=[];
            for(let item of value)
            {
                fields.push(PDFControlOptionsGenerator.GetControlOptions(item));
            }

            return fields;
        }
    }

}


export class SectionOption extends StoreBase{
    @observable
    Type:SectionOptionsEnum;
    @observable
    Height:number;

    protected LoadDefaultValues() {
        this.Type=SectionOptionsEnum.header;
        this.Height=0;
    }

}



export class PDFDocumentOptions extends StoreBase{
    @observable
    Id:number;
    @observable
    @StoreDataType(PageOptions)
    Pages:PageOptions[];
    @observable
    Styles='';
    @observable
    DocumentSettings:DocumentSettings;
    @observable
    FormId:string;
    @observable
    Name:string;


    protected LoadDefaultValues() {
        this.Pages=[];
        this.Styles=this.GetDefaultStyles();
        this.Id=0;
        this.DocumentSettings=new DocumentSettings().Merge();
        this.FormId='';
        this.Name='New Form';

    }

    private GetDefaultStyles() {
        return `
             .PDFElement{
                border:1px solid transparent;
             }
                
             .PDFElement.Text{
                text-align:left;
             }
             
             .PDFElement p{
                line-height:14px;
                font-size:14px;
                margin:0;
                padding:0;
             
             }
             
             .PDFElement.Field{
                text-align:left;
             }
             
             .PDFElement.Text .TextLabel{
                font-weight:bold;    
                vertical-align:top;            
             }
             
             .PDFElement.Text .TextValue p{
                margin-bottom:4px;                            
             }
             
            
             
             .PDFElement.Field .FieldLabel{
                font-weight:bold;    
                vertical-align:top;            
             }
             
             .PDFElement.Field Table{
                width:100%;
             }
             
             .PDFElement.Field .FieldLabel .Top{              
                margin-bottom:2px;
             }
             .PDFElement.Field .FieldLabel .Bottom{              
                margin-top:2px;
             }
             .PDFElement.Field .FieldLabel .Left{              
                margin-right:2px;
             }
             .PDFElement.Field .FieldLabel .Right{              
                margin-left:2px;
             }
             
        
        `;
    }
}


export enum CurrencyPositionEnum {
    Left='left',
    Right='right',
    LeftWithSpace='left_space',
    RightWithSpace='right_space'
}

export class DocumentSettings extends StoreBase{
    Width:number;
    Height:number;
    @StoreDataType(Number)
    Notifications:any[];
    CreatedFromTemplate:boolean;
    PageType:PageTypeEnum;
    BackgroundImageId:string;
    BackgroundImageURL:string;
    EnableMultiplePage:boolean;
    BackgroundStyle:BackgroundStyleEnum;
    HideFooter:boolean;
    HideHeader:boolean;
    Orientation:'landscape'|'portrait';
    @observable
    FileName:string;
    BaseStyles:string;
    CurrencySettings:CurrencySettings;
    @StoreDataType(Object)
    FormattedFileName:any;
    PrintWhenCreated:boolean;
    PrinterId:string;


    protected LoadDefaultValues() {
        this.Width=794;
        this.Height=1123;
        this.PageType=PageTypeEnum.A4;
        this.Orientation='portrait';
        this.EnableMultiplePage=false;
        this.FileName='PDFDocument.tsx';
        this.HideFooter=false;
        this.HideHeader=false;
        this.BackgroundImageId='';
        this.BackgroundImageURL='';
        this.BackgroundStyle=BackgroundStyleEnum.fill;
        this.CreatedFromTemplate=false;
        this.BaseStyles='';
        this.CurrencySettings=new CurrencySettings().Merge();
        this.Notifications=[];
        this.FormattedFileName=null;
        this.PrintWhenCreated=false;
        this.PrinterId='';
    }


}

export enum BackgroundStyleEnum {
    repeat = 'repeat',
    top = 'top',
    left = 'left',
    right = 'right',
    bottom = 'bottom',
    center = 'center',
    fill='fill'
}

export enum PageTypeEnum {
    A2="A2",
    A3="A3",
    A4="A4",
    A5="A5",
    A6="A6",
    A7="A7"
}

